<template>
    <header>
        <div class="fixwrap">
            <transition appear name="appear-right">
                <nav>
                    <a href="#" id="menu-button" @click="showMenu()">
                        <p>menu</p>
                        <div id="menu-icon">
                            <div></div>
                            <div></div>
                        </div>
                    </a>
                    <ul id="menu">
                        <li><a href="#" v-scroll-to="'#projects'">Projects</a></li>
                        <li><a href="#" v-scroll-to="'#profile'">Profile</a></li>
                        <li><a href="#" v-scroll-to="'#contact'">Contact</a></li>
                    </ul>
                </nav>
            </transition>
        </div>
    </header>
</template>

<script>
    export default {
        name: "StickyMenu",
        methods: {
            showMenu: function () {
                let x = document.getElementById("menu");
                (x.style.transform === "scale(1,1)") ? (x.style.transform = "scale(1,0)") : (x.style.transform = "scale(1,1)");
            }
        }
    }
</script>

<style scoped>
    #menu-button {
        display: none;
    }

    @media only screen
    and (min-device-width: 320px)
    and (max-device-width: 600px)
    and (-webkit-min-device-pixel-ratio: 2) {

        #menu {
            display: block;
            transform: scale(1,1);
            transition: transform .5s cubic-bezier(0.215, 0.61, 0.355, 1);
        }

        #menu-button {
            display: flex;
            align-items: center;
        }

        #menu-button p {
            margin-right: 1rem;
        }


        #menu-icon {
            display: block;
        }

        #menu-icon div {
            height: 1px;
            margin-top: 0.5rem;
            margin-bottom: 0.5rem;
            background-color: rgba(57, 224, 151, 1);
            display: block;
            transition: 0.33s;
            width: 1.5rem;
        }

    }
</style>